export default __webpack_public_path__ + "fk-cp-zion/img/plus_aef861.png";